import React, { useEffect } from 'react';
import PropTypes from "prop-types";
import { Button, Table, UncontrolledTooltip } from 'reactstrap';
import { translate } from "react-translate";
import LoadingLocal from 'plugins/TS-lib-utils-public/components/Loading/LoadingLocal';
import { useDispatch } from "react-redux";
import { useHistory } from 'react-router-dom';
import { actionSetEditOrder, actionDeleteOrder } from 'store/actions/practiceOrdersActions';
import { useSelector } from 'react-redux';
import { 
  actionGetKitTypes, 
} from 'store/actions/kitsActions';

//Sweet alert
import SweetAlert from "react-bootstrap-sweetalert";
import { actionSweetAlert } from "store/actions/commonActions";

//moment
import moment from "moment";
import { toast } from 'react-toastify';

const TablePracticeOrders = (props) => {
    const { data, loading, page, callback } = props;
    const { t } = props;
    const dispatch = useDispatch();
    const history = useHistory();
    const kitTypes = useSelector(state => state.kitsReducer.types);

    const editOrder = (e, order) => {
        e.preventDefault();
        dispatch(actionSetEditOrder({...order}));
        history.push(`/admin/practice-orders/form/${order._id}`);
    }

    const deleteOrder = (e, order) => {
        e.preventDefault();

        dispatch(
            actionSweetAlert(
                <SweetAlert
                    warning
                    title={t("order-cancel-title")}
                    onConfirm={() => {
                        dispatch(actionDeleteOrder(order._id));
                        dispatch(actionSweetAlert(null));
                    }}
                    onCancel={() => dispatch(actionSweetAlert(null))}
                    confirmBtnBsStyle="primary"
                    cancelBtnBsStyle="info"
                    confirmBtnText={t("order-cancel-confirm-btn")}
                    cancelBtnText={t("order-cancel-deny-btn")}
                    showCancel
                >
                    {t("order-cancel-description")}
                </SweetAlert>
            )
        );
    }

    useEffect(() => {
        if (!Object.keys(kitTypes).length) {
            dispatch(actionGetKitTypes());
        }
    }, []);

    const copyIdToClipboard = (e, orderId) => {
        e.preventDefault();
        navigator.clipboard.writeText(orderId);
        toast.success(t("id-copied"));
    };

    return (
        <>
            {loading ?
                (<LoadingLocal />)
                :
                (<div className="table-data">
                    <Table>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th> {t("practice")}</th>
                                <th> {t("status")}</th>
                                <th> {t("created-at")}</th>
                                <th> {t("kits")}</th>
                                <th> {t("actions")} </th>
                                <th></th>
                            </tr>
                        </thead>

                        {data.length > 0 && (data.map((p, index) => {
                            return (
                                <tbody key={index}>
                                    <tr>
                                        <th>

                                            <Button
                                                size="md"
                                                color="info"
                                                onClick={(e) => copyIdToClipboard(e, p._id)}
                                                id={`tooltip-detail-${index}`}
                                            >
                                                {t("copy-btn")}
                                            </Button>

                                            <UncontrolledTooltip placement="top" target={`tooltip-detail-${index}`}>
                                                {p._id}
                                            </UncontrolledTooltip>

                                        </th>
                                        <th>{p.ordered_by.practice_name} <br/><small>({p.ordered_by.practice_owner.firstName} {p.ordered_by.practice_owner.lastName} {p.ordered_by.practice_owner.auth_user_id})</small></th>
                                        <th>{t(p.status.status_id)}</th>
                                        <th>{moment(p.created_at).format("DD-MM-YYYY HH:mm:ss")}</th>

                                        <th>{p.requested_kits.map(rk => {
                                            return (
                                                <>
                                                    {rk.requested_quantity > 0 ? 
                                                        <p 
                                                            className={
                                                                p.status.status_id !== "o_st_cancel" 
                                                                ? `${rk.prepared_quantity >= rk.requested_quantity ? "fulfilled" : "pending"}-kit-pill`
                                                                : "order-cancelled"}
                                                        >
                                                            {rk.kit_type_id}: {rk.prepared_quantity}/{rk.requested_quantity}
                                                        </p>
                                                    : <></>
                                                    }
                                                </>
                                            )
                                        })}</th>

                                        <th>
                                            {p.status.status_id !== "o_st_cancel" ? (
                                                <>
                                                    <Button
                                                        onClick={e => editOrder(e, p)}
                                                        className="btn-icon btn-round"
                                                        color="warning"
                                                        size="md"
                                                    >
                                                        <i className="fa fa-edit" />
                                                    </Button>
                                                    <Button
                                                        onClick={e => deleteOrder(e, p)}
                                                        className="btn-icon btn-round"
                                                        color="danger"
                                                        size="md"
                                                    >
                                                        <i className="fa fa-times" />
                                                    </Button>
                                                </>
                                            ) : <></>}
                                            
                                        </th>
                                    </tr>
                                </tbody>
                            )
                        })
                        )}
                    </Table>
                </div>)}

        </>
    );
};
TablePracticeOrders.defaultProps = {
    data: [],
    loading: true
};

TablePracticeOrders.propTypes = {
    data: PropTypes.array,
    loading: PropTypes.bool
};

export default translate("practice-orders")(TablePracticeOrders);